<div class="flex-vertical gap-16 width-100pc">
  <div class="flex-horizontal flex-center gap-16">
    <div>
      {{ totalCount }} <span *ngIf="totalCount > 1">configurations de fiches conseils</span
      ><span *ngIf="totalCount < 2">configuration de fiche conseil</span>
    </div>
  </div>

  <div class="width-100pc">
    <oui-table *ngIf="!isLoading && dataSource.filteredData.length > 0">
      <table mat-table [dataSource]="dataSource" matSort #configSort="matSort">
        <ng-container *ngFor="let columnconfig of columnSelection" matColumnDef="{{ columnconfig.header }}">
          <ng-container *ngIf="columnconfig?.withSort">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [disableClear]="true"
              [ngClass]="{ 'header-right': columnconfig.isRightAligned }">
              {{ columnconfig.hideHeader ? '' : columnconfig.header }}
            </th>
          </ng-container>
          <ng-container *ngIf="!columnconfig?.withSort">
            <th mat-header-cell *matHeaderCellDef [ngClass]="{ 'header-right': columnconfig.isRightAligned }">
              {{ columnconfig.hideHeader ? '' : columnconfig.header }}
            </th>
          </ng-container>
          <td mat-cell *matCellDef="let config">
            <ng-container [ngSwitch]="columnconfig.header">
              <ng-container *ngSwitchCase="'Type'">
                <div>
                  <oui-tag *ngIf="config?.type === 0" type="status" declination="secondary" status="completed"
                    >Digitale</oui-tag
                  ><oui-tag *ngIf="config?.type === 1" type="status" declination="secondary" status="todo"
                    >Avec documents</oui-tag
                  ><oui-tag *ngIf="config?.type === 2" type="status" status="pending">Sans documents</oui-tag>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Statut'">
                <div>
                  <oui-tag *ngIf="displayColumnInfo(columnconfig, config) === 'active'" type="status" status="completed"
                    >Actif</oui-tag
                  ><oui-tag
                    *ngIf="displayColumnInfo(columnconfig, config) === 'archived'"
                    type="status"
                    status="pending"
                    >Archive</oui-tag
                  >
                  <oui-tag
                    *ngIf="displayColumnInfo(columnconfig, config) === 'draft'"
                    type="status"
                    status="in-progress"
                    >Brouillon</oui-tag
                  >
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Commentaire de version'">
                <div>
                  <oui-infos-bulle
                    bulleTitle="Commentaire de version"
                    *ngIf="config?.conseilConfig?.commentaireDeVersion">
                    <div [innerText]="config?.conseilConfig?.commentaireDeVersion"></div>
                  </oui-infos-bulle>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Majeur'">
                <div *ngIf="displayColumnInfo(columnconfig, config) === 'true'">
                  <oui-icon class="primary-icon">check_small</oui-icon>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Download template'">

                <app-download-template
                  *ngIf="displayColumnInfo(columnconfig, config)"
                  [templateName]="displayColumnInfo(columnconfig, config)!"></app-download-template>
              </ng-container>
              <ng-container *ngSwitchCase="'delete'">
                <app-delete-draft-conseil-config
                  *ngIf="displayColumnInfo(columnconfig, config)"
                  [configId]="displayColumnInfo(columnconfig, config)!"
                  (onDeleteConfig)="fetchData(true)"></app-delete-draft-conseil-config>
              </ng-container>
              <ng-container *ngSwitchCase="'Activer'">
                <div *ngIf="displayColumnInfo(columnconfig, config)" class="flex-horizontal">
                  <app-activate-conseil-config
                    [configId]="displayColumnInfo(columnconfig, config)!"
                    (onActivateConfig)="fetchData(true)"></app-activate-conseil-config>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Nom du fichier template'">
                <div>{{ displayColumnInfo(columnconfig, config) ?? '-' | templateName }}</div>
              </ng-container>
              <ng-container *ngSwitchCase="'Config'">
                <div class="content-right">
                  {{ displayColumnInfo(columnconfig, config) ?? '-' }}
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <div [ngClass]="{ 'content-right': columnconfig?.isRightAligned }">
                  {{ displayColumnInfo(columnconfig, config) ?? '-' }}
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <ng-container>
          <tr
            [class.interactive]="true"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="rowClick(row)"></tr>
        </ng-container>
      </table>
    </oui-table>
    <div class="etat-vide-container" *ngIf="isLoading || dataSource.filteredData.length === 0">
      <oui-etat-vide *ngIf="!isLoading" title="Aucun résultat" icon="live_help"></oui-etat-vide>
      <oui-loading *ngIf="isLoading" class="flex-horizontal flex-center justify-center"></oui-loading>
    </div>
  </div>
</div>
